import React from 'react';
import { Icon } from 'antd';
import ActionBtn from '../../shared/ui/ActionBtn/ActionBtn';
import { ReactComponent as ConfirmNotificationIcon } from '../../../../resource/ConfirmNotificationIcon.svg';
import {
  useOnlyUnreadState,
  useOnlyUnreadDispatch,
  onlyUnreadUpdater,
} from './lib';

const ToggleOnlyUnreadBtn = ({ disabled = false }) => {
  const onlyUnread = useOnlyUnreadState();
  const setOnlyUnread = useOnlyUnreadDispatch();

  return (
    <ActionBtn
      tooltipProps={{
        title: onlyUnread ? 'Показать все' : 'Показать непрочитанные',
      }}
      onClick={() => setOnlyUnread(onlyUnreadUpdater)}
      style={{ fontSize: '20px', ...(onlyUnread ? { color: '#5c9aff' } : {}) }}
      disabled={!onlyUnread && disabled}
    >
      <Icon component={ConfirmNotificationIcon} />
    </ActionBtn>
  );
};

export default ToggleOnlyUnreadBtn;
